import React, {useEffect} from "react";
import {CustomerMnaNeedsDto} from "../../../model/customer/dto/customer-mna-needs-dto";
import classnames from "classnames/bind";
import styles from "../mna-info.module.scss";
import {isShowTempSaveBtn, needsBtnTitle} from "../mna-info";

const cx = classnames.bind(styles);

interface NeededSaveBtnProps {
    needs: CustomerMnaNeedsDto
    needsType: string;
    setIsDraft: (value: React.SetStateAction<boolean>) => void
}

const NeedsSaveBtn = ({needs, needsType, setIsDraft}: NeededSaveBtnProps) => {

    return (
        <>
            {/* 현재 클릭한 타입이 검토가능이 아닌 상태 && (신청을 안 한 상태 || 신청했지만 검토가능으로 신청한 상태) */}
            {isShowTempSaveBtn(needs, needsType) && <button className={cx('temporary-save-btn')} type='submit' onClick={() => setIsDraft(true)}>임시 저장하기</button>}
            <button className={cx('save-btn')} type='submit' onClick={() => setIsDraft(false)}>
                <i></i>{needsBtnTitle(needs, needsType)}
            </button>
        </>
    );
}

export default NeedsSaveBtn;